import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

const selectDomain = (state) => state.samplerListing || initialState;

export const selectSamplers = createSelector(
  [selectDomain],
  (state) => state.samplers
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);
export const selectTableLoading = createSelector(
  [selectDomain],
  (state) => state.tableLoading
);
export const selectStateLoading = createSelector(
  [selectDomain],
  (state) => state.stateLoading
);

export const selectSamplerCount = createSelector(
  [selectDomain],
  (state) => state.samplerCount
);

export const selectDistricts = createSelector(
  [selectDomain],
  (state) => state.districts
);

export const selectStates = createSelector(
  [selectDomain],
  (state) => state.states
);
export const selectStatesSorted = createSelector(
  [selectStates],
  (states) => {
    if (!states) return [];
    return [...states].sort((a, b) => a.name.localeCompare(b.name));
  }
);
export const selectAgencies = createSelector(
  [selectDomain],
  (state) => state.agencies
);

export const selectDistrictsOfMultipleStates = createSelector(
  [selectDomain],
  (state) => state.districtsOfMultipleStates
);